import moment from "moment";
import FileDownload from "js-file-download";
import { createToast } from "src/actions/appActions";
import { logout } from "../actions/authActions";
import { apiDocumentURI } from "src/env";

function sanitizeFilename(filename) {
  return filename.replace(/[:"]/g, "_").replace(/^_+|_+$/g, "");
}

export async function downloadDocument({ raNumber, fileName, auth, dispatch, version }) {
  const { blob, filename } = await documentRequest({
    path: `${raNumber}/${fileName}`,
    version,
    auth,
    dispatch,
  });

  if (!blob) {
    return;
  }

  const safeFilename = sanitizeFilename(filename);
  FileDownload(blob, safeFilename);
}

export async function viewDocument({ raNumber, fileName, auth, dispatch, version }) {
  const { blob } = await documentRequest({
    path: `${raNumber}/${fileName}`,
    version,
    auth,
    dispatch,
  });

  if (!blob) {
    return;
  }

  const fileBlobURL = URL.createObjectURL(blob);
  const newWindow = window.open(fileBlobURL, "_blank");
  return newWindow;
}

async function fetchWithTimeout(resource, options) {
  const { timeout = 31000 } = options;
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);
  return response;
}

export async function documentRequest({ path, auth: { expires, token }, dispatch, version }) {
  const currentTime = moment().format();
  if (expires <= currentTime) {
    dispatch(logout());
    dispatch(
      createToast({
        type: "error",
        message: "Your session has expired. Please login again to continue.",
      })
    );
    return;
  }

  try {
    const response = await fetchWithTimeout(`${apiDocumentURI}/${path}/${version ? version : ""}`, {
      mode: "cors",
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/pdf",
        "Content-Type": "application/pdf",
      },
    });

    const filename = response.headers.get("content-disposition")?.split("; ")[1]?.split("=")[1];
    const blob = await response.blob();
    return {
      blob,
      filename,
    };
  } catch (error) {
    dispatch(
      createToast({
        type: "error",
        message:
          "Unable to download document. Please ensure pop-ups are enabled or try again later.",
      })
    );

    return null;
  }
}
